// extracted by mini-css-extract-plugin
module.exports = {"content":"PublicationUrlsList_content__dCYEh","flag":"PublicationUrlsList_flag__1NNSn"};